module.exports = __webpack_public_path__ + "media/images/sports_icons/polo-53aa41565bb5ff4f2f24eb6c466a6f6c.png";